import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextStringStatic from '../../../components/CLocalizedTextStringStatic';
import { PageRoutes } from '../../../enums/enums';
import { useAppDispatch } from '../../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../../store/appSlice';

export default function PUserTrackingOutlet() {
  const dispatch = useAppDispatch();
  const allSignUpRequestsTitle = CLocalizedTextStringStatic('signUp.all.requests.title');
  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.SIGN_UP_REQUESTS_OUTLET, allSignUpRequestsTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, allSignUpRequestsTitle]);
  return <Outlet />;
}
